import { inject, injectable } from "inversify";
import { ProjectExpenseRepository } from "../../../data/repositories/project-expense.repository";
import { ExpenseSubType } from "../../models/expenses/sub-type.model";

@injectable()
export class GetTravelSubTypesUseCase {
    constructor(
        @inject(ProjectExpenseRepository)
        private readonly projectExpenseRepository: ProjectExpenseRepository,
    ) { }

    async execute(): Promise<ExpenseSubType[]> {
        const typesResult = await this.projectExpenseRepository.getTravelSubTypes();

        return typesResult.fold(
            () => [],
            (travelSubTypes) => travelSubTypes,
        );
    }
}
